import * as React from "react"
import { EyeNoneIcon, EyeOpenIcon } from "@radix-ui/react-icons"
import {
  PasswordToggleField,
  PasswordToggleFieldIcon,
  PasswordToggleFieldInput,
  PasswordToggleFieldToggle,
} from "@radix-ui/react-password-toggle-field"

import { cn } from "@/components/ui/helpers/utils"

const PasswordToggleInput = React.forwardRef<
  React.ElementRef<typeof PasswordToggleFieldInput>,
  React.ComponentPropsWithoutRef<typeof PasswordToggleFieldInput>
>(({ className, ...props }, ref) => (
  <PasswordToggleField>
    <div className={"relative"}>
      <PasswordToggleFieldInput
        ref={ref}
        className={cn(
          `
            flex h-10 w-full rounded-lg border-gray-300 bg-white px-5 py-1.5 text-base ring-0 outline-hidden
            placeholder:text-muted-foreground
            hover:border-black
            focus:border-gray-200 focus:ring-0
            disabled:cursor-not-allowed disabled:opacity-50
          `,
          className
        )}
        {...props}
      />
      <PasswordToggleFieldToggle className={"absolute top-3 right-3"}>
        <PasswordToggleFieldIcon visible={<EyeOpenIcon />} hidden={<EyeNoneIcon />} />
      </PasswordToggleFieldToggle>
    </div>
  </PasswordToggleField>
))
PasswordToggleInput.displayName = PasswordToggleFieldInput.displayName

export { PasswordToggleInput }
